var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4103 8.93204L11.8767 6.05825H8.9589V4.19417C8.9589 3.40796 9.36658 2.64078 10.6734 2.64078H12V0.194175C12 0.194175 10.7961 0 9.645 0C7.24192 0 5.67123 1.37631 5.67123 3.86796V6.05825H3V8.93204H5.67123V16C6.7856 16 7.82108 16 8.9589 16V8.93204H11.4103Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cb01547ad8339c90baecdfdf1c6506f0.svg";
export { ForwardRef as ReactComponent };